import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_mobile_menu = _resolveComponent("mobile-menu")!
  const _component_q_footer = _resolveComponent("q-footer")!
  const _component_left_menu = _resolveComponent("left-menu")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_q_page_container = _resolveComponent("q-page-container")!
  const _component_q_layout = _resolveComponent("q-layout")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    class: "full-height",
    view: "hhh lpr fFf"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_footer, {
        bordered: "",
        class: "lt-sm bg-white"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_mobile_menu)
        ]),
        _: 1
      }),
      (_ctx.useDrawerMenu && _ctx.menu)
        ? (_openBlock(), _createBlock(_component_q_drawer, {
            key: 0,
            side: "left",
            bordered: "",
            "show-if-above": false,
            breakpoint: 0,
            "mini-to-overlay": "",
            mini: _ctx.miniState && _ctx.miniEnabled,
            width: 240,
            onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.miniState = false)),
            onMouseout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.miniState = true)),
            "mini-width": 80,
            "model-value": _ctx.menuDrawer
          }, {
            default: _withCtx(() => [
              _createVNode(_component_left_menu, {
                "mini-state": _ctx.miniState && _ctx.miniEnabled,
                "on@disableMiniState": _ctx.disableMiniState,
                "on@enableMiniState": _ctx.enableMiniState
              }, null, 8, ["mini-state", "on@disableMiniState", "on@enableMiniState"])
            ]),
            _: 1
          }, 8, ["mini", "model-value"]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_page_container, { class: "full-height bg-grey-light-lighter" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view, { name: "main" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}